import React from 'react';
import EventActions from './EventActions';
import moment from 'moment';

export default class ShopNowConfirm extends React.Component {
	constructor(props) {
		super(props);
    }

    setEvent(selectedEvent) {
        EventActions.setEventAndRedirect(selectedEvent);
	}

	backToList() {
		eventCode = '';
		this.props.backToList();
	}

	render() {
		return (
			<div className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.Events.ShopNowTitleText"]} {this.props.selectedEvent.name}</div>
					<div className="description">{this.props.resources["PWS.Events.ShopNowDescriptionText"]} <strong>{this.props.selectedEvent.facilitatorName}</strong></div>
				</div>
				<div id="publicPartiesList" className="section-wrapper clearfix">
					<div className="sectionButtons" style={{textAlign: 'center', margin: '12px 0'}}>
						<span>{this.props.resources["PWS.Events.ShopNowContinue"]}<br/></span>
                        <button className="bookPartyBtn" onClick={this.setEvent.bind(this, this.props.selectedEvent)}>{this.props.resources['PWS.Events.ShopNowYesButton']}</button>
						<button className="bookPartyBtn" onClick={this.backToList.bind(this)}>{this.props.resources['PWS.Events.ShopNowNoButton']}</button>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/ShopNowConfirm.js